import api from '../httpClient';

export const training = {
  summary: (params?: { course_id?: number; view?: 'library' }) =>
    api.get('/api/training/summary/', { params }).then((response) => response.data),
  flowAssignments: () =>
    api.get('/api/training/flow-assignments/').then((response) => response.data),
};
